// pages/sapProcessMapIssueKw.js — keywords that link a Process Map step to Solman tickets
// (GET /api/sap-procmap/issues). Transaction codes in the step's `tc` are added automatically.
// Keyed by flow:step first, then by step id alone (step ids repeat across landscapes).
export const ISSUE_KW = {
  pr: ['PURCHASE REQ', 'RELEASE PR', 'PR RELEASE', 'DELETE PR', 'CANCEL PR', 'QTY PR', 'ME54N', 'ME55'],
  rfq: ['RFQ', 'QUOTATION', 'ME41', 'ME47', 'ME49'],
  po: ['PURCHASE ORDER', 'PO RELEASE', 'RELEASE PO', 'ME28', 'ME29N', 'CONTRACT'],
  gr: ['GOODS RECEIPT', 'MIGO', 'CANCEL GR', 'GRN', 'MVT 101', 'STOCK OPNAME'],
  qi: ['INSPECTION LOT', 'USAGE DECISION', 'REVERSE QC', 'CANCEL QI', 'QA32', 'QA11', 'MIC '],
  iv: ['MIRO', 'INVOICE VERIFICATION', 'GR/IR', 'MR8M'],
  pay: ['PAYMENT', 'F-53', 'F110', 'BANK', 'VENDOR CODE', 'DOWN PAYMENT', 'WITHHOLDING'],
  ord: ['PROCESS ORDER', 'PRODUCTION ORDER', 'JOB ORDER', 'TECO', 'CLOSE MO', 'COR1', 'COR2', 'CO01', 'BOM', 'ROUTING'],
  gi: ['GOODS ISSUE', 'MVT 261', 'BACKFLUSH', 'RESERVATION'],
  conf: ['CONFIRMATION', 'CONFIRMASI', 'COR6', 'CO11', 'CANCEL CONFIRM'],
  grp: ['CO-PRODUCT', 'BY-PRODUCT', 'PRODUCTION ENTRY', 'MVT 101'],
  qi4: ['INSPECTION', 'REVERSE QC', 'QA32'],
  set: ['SETTLEMENT', 'KO88', 'CO88', 'VARIANCE'],
  so: ['SALES ORDER', 'VA01', 'VA02', 'PRICE', 'PRICING', 'DIST CHANNEL', 'CREDIT LIMIT', 'TOP '],
  dl: ['DELIVERY', 'VL01', 'VL02', 'PICKING'],
  shp: ['SHIPMENT', 'SHIPPING TYPE', 'S. COST', 'SHIPMENST', 'VI01', 'VT01', 'VT02', 'VESSEL', 'FREIGHT'],
  pgi: ['PGI', 'GOODS ISSUE', 'VL09'],
  pf: ['PROFORMA', 'PRO FORMA', 'PACKING LIST'],
  bil: ['BILLING', 'KURS', 'EXCHANGE RATE', 'INVOICE', 'VF01', 'VF02', 'VF11', 'FAKTUR', 'YIN1', 'YIN3', 'OUTPUT TYPE'],
  ar: ['CUSTOMER', 'RECEIVABLE', 'FBL5N', 'CLEARING'],
  in: ['INCOMING PAYMENT', 'F-28', 'CLEARING'],
  nt: ['NOTIFICATION', 'IW21', 'IW22'],
  pl: ['MAINTENANCE PLAN', 'TASK LIST', 'EQUIPMENT', 'FUNCTIONAL LOC', 'CALIBRATION', 'MEASURING POINT', 'IP10'],
  wo: ['WORK ORDER', 'MAINTENANCE ORDER', 'IW31', 'IW32', 'PM ORDER'],
  sp: ['SPARE PART', 'RESERVATION', 'MVT 261'],
  cf: ['IW41', 'TECO', 'CONFIRMATION'],
  pms: ['SETTLEMENT', 'KO88', 'IW38'],
  mmpv: ['PERIOD', 'MMPV', 'MMRV', 'UNLOCK', 'OPEN TCODE'],
  ks: ['SETTLEMENT', 'CO88', 'ALLOCATION', 'CYCLE'],
  ck: ['CKMLCP', 'UNLOCK', 'UNLOCK', 'ACTUAL COST', 'SCE', 'COST ESTIMATE', 'ACTIVITY RATE', 'CK11'],
  ml: ['MATERIAL LEDGER', 'CKM3', 'REVALUATION'],
  ob52: ['POSTING PERIOD', 'OB52', 'CLOSING'],
  ct: ['CONTRACT', 'TANK'], svo: ['SERVICE ORDER'], co: ['CUSTOMER OIL'], cs: ['CUSTOMER STOCK'],
  svb: ['SERVICE BILLING'], par: ['RECEIVABLE'], cod: ['CUSTOMER STOCK'],
  cn: ['CREDIT NOTE', 'DEBIT NOTE'], acc: ['COST CENTER', 'GL ACCOUNT', 'ACCOUNT ASSIGNMENT'],
};

export function issueKeywords(flowKey, step) {
  const tc = String(step.tc || '').split(/[·,/]/).map(s => s.replace(/mvt.*/i, '').trim()).filter(s => /^[A-Z][A-Z0-9_]{2,}$/.test(s));
  const extra = ISSUE_KW[flowKey + ':' + step.id] || ISSUE_KW[step.id] || [];
  return [...new Set([...tc, ...extra])].slice(0, 12);
}
